import { render } from "./dopa.html?vue&type=template&id=0db3af06&ts=true"
import script from "./dopa.vue?vue&type=script&lang=ts"
export * from "./dopa.vue?vue&type=script&lang=ts"

import "./dopa.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/customer/line/line-web-loyalty/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__